import { useBookingState } from 'widgets/booking/lib/hooks/useBookingState';
import { useBookingActions } from 'widgets/booking/lib/hooks/useBookingActions';
import { useBookingAwaitByTimer } from 'widgets/booking/lib/hooks/useBookingAwaitByTimer';
import { useBookingEvents } from 'widgets/booking/lib/hooks/useBookingEvents';

//TODO сложно поддерживать и понимать рефакторинг подключаемых хуков
//fetchDataAfterBooking где то передается как булин а здесь функция не понятно разобраться
export const useBookingEffects = (
	toProhibitClose: (isClose?: boolean) => void,
) => {
	const {
		successClose,
		isDisabledBooking,
		isNewBooking,
		disableBooking,
		enableBooking,
		idempotencyKey,
		getWaitingOrdersList,
		bookingError,
		setBookingError,
		clearError,
	} = useBookingState();

	const {
		removeRestrictions,
		onSuccessBookingActions,
		onErrorBookingActions,
		prohibitBookingAgain,
	} = useBookingEvents({
		toProhibitClose,
		enableBooking,
		successClose,
		setBookingError,
	});

	const {
		bookOrEdit,
		toastAwaitId,
		addToWaitingList,
		removeFromWaitingList,
		setToastAwaitId,
		saveOrderOrBook,
		saveOrderOrBooking,
	} = useBookingActions({
		toProhibitClose,
		isNewBooking,
		prohibitBookingAgain,
		onErrorBookingActions,
		disableBooking,
		successClose,
		getWaitingOrdersList,
		idempotencyKeyRef: idempotencyKey,
    enableBooking,
	});

	useBookingAwaitByTimer({
		bookOrEdit,
		removeRestrictions,
		setToastAwaitId,
		onSuccessBookingActions,
		onErrorBookingActions,
		toastAwaitId,
		idempotencyKeyRef: idempotencyKey
	});

	return {
		isDisabledBooking,
		addToWaitingList,
		removeFromWaitingList,
		saveOrderOrBook,
		saveOrderOrBooking,
		clearError,
		successClose,
		getWaitingOrdersList,
		bookingError,
		bookOrEdit,
	};
};
